import styled from '@emotion/styled/macro'

import mediaQuery from 'share/utils/mediaQuery'

const MainContentWrapper = styled('section')`
  --content-view-height: calc(calc(var(--vh) * 100) - var(--nav-bar-height));
  --over-flow: auto;

  height: var(--content-view-height);
  overflow: var(--over-flow);
  text-align: center;
`

const MainContentContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: var(--content-view-height);

  ${mediaQuery('laptop')} {
    & .ui-dashboard-menu {
      background-color: white;
      bottom: 0px;
      position: fixed;
      z-index: 100;
    }
  }
`

export { MainContentContainer, MainContentWrapper }
